<div class="disclaimer-component">
  <div class="disclaimer-title">Disclaimer:</div>
  @if (settings.disclaimer) {
    <div class="disclaimer-message">
      {{ settings.disclaimer }}
    </div>
  }
  <div class="disclaimer-message">
    At Pelican Procurement Services, we understand your concerns about potential allergens in the foods you eat and aim
    to provide you with accurate reliable information. The information presented on this website is derived from
    multiple sources and maybe updated at any time.
  </div>
  <div class="important" piKeyColorBackground>
    You should always speak with a member of staff directly to verify any information displayed on this website and
    closely check that packaging of any pre-packaged goods. Additionally, if you have a food allergy, or are concerned
    about allergens in your food, please speak to a member of staff before ordering.
  </div>
  <div class="disclaimer-message">
    By using this website, it will be deemed that you have accepted and agreed that Pelican Procurement Services Limited
    does not guarantee (nor accept any responsibility for) the accuracy of the data presented and will not be
    responsible for any reliance that you may place on such data.
  </div>

  <div class="ok-btn-wrapper">
    <button class="ok-btn" piKeyColorBackground routerLink="/home" (click)="closeDisclaimerPage()">OK</button>
  </div>
</div>
